import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  forwardRef,
  Input,
} from '@angular/core';

import marked from 'marked';
import DOMPurify from 'dompurify';
import { NbValueAccessor } from '@app/common/basic/models/nb-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'nb-markdown',
  templateUrl: './nb-markdown.component.html',
  styleUrls: ['./nb-markdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbMarkdownComponent),
      multi: true,
    },
  ],
})
export class NbMarkdownComponent extends NbValueAccessor<string> implements OnInit, AfterViewInit {
  @ViewChild('markdown')
  markdown: ElementRef;

  @Input()
  readonly = false;

  @Output()
  change = new EventEmitter<string | number>();

  renderer = new marked.Renderer();

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.renderer.link = function(...args) {
      const link = marked.Renderer.prototype.link.apply(this, args);
      return link.replace('<a', "<a target='_blank'");
    };
  }

  ngAfterViewInit() {
    // setTimout tmp fix for https://github.com/angular/angular/issues/14988
    // ValueAccessor.writeValue is being called twice, first time with a phantom null value
    setTimeout(() => {
      this.markdown.nativeElement.innerHTML = marked(this?.value ?? '', { breaks: true, renderer: this.renderer });
    });
  }

  onMarkdownContentChange(val) {
    this.writeValue(val);
    this.change.emit(val);
    this.markdown.nativeElement.innerHTML = DOMPurify.sanitize(marked(val, { breaks: true, renderer: this.renderer }));
  }

  importCustomers(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    if (files && files.length > 0) {
      const file = files.item(0);
      const reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = this.onFileLoad(reader);
    }
  }

  private onFileLoad(reader: FileReader) {
    return () => {
      this.onMarkdownContentChange(reader.result);
    };
  }
}
